import { getCurrencies, getOrderOrigins, getPurchasingShippingMethods, getPurchasingShippingTerms, getSalesShippingMethods, getTaxRates, getWarehouseShippingMethods } from 'src/core/api/apiRequests';
import { useResponse } from 'src/core/api/useResponse';

export const useCurrencies = (refreshKey = 0) => {
    return useResponse<CurrencyModel[]>({
        requestFunction: getCurrencies,
        dependency: [refreshKey],
    });
};

export const useOrderOrigins = () => {
    return useResponse<any[]>({
        requestFunction: getOrderOrigins,
    });
};

export const useTaxRates = () => {
    return useResponse<any[]>({
        requestFunction: getTaxRates,
    });
};

export const useSalesShippingMethods = () => {
    return useResponse<any[]>({
        requestFunction: getSalesShippingMethods,
    });
};

export const useWarehouseShippingMethods = () => {
    return useResponse<any[]>({
        requestFunction: getWarehouseShippingMethods,
    });
};

export const usePurchasingShippingMethods = () => {
    return useResponse<any[]>({
        requestFunction: getPurchasingShippingMethods,
    });
};

export const usePurchasingShippingTerms = () => {
    return useResponse<any[]>({
        requestFunction: getPurchasingShippingTerms,
    });
};

export interface CurrencyModel {
    Currency: {
        Key: number;
        Value: string;
    };
    ModifyDate: string;
    Description: string;
    Enabled: boolean;
    FixedRate: number | null;
    FixedRateValidFrom: string;
    FixedRateByUser: {
        Key: number | null;
        Value: string | null;
    };
}
